// extracted by mini-css-extract-plugin
export default {"refresh":"ErrorBoundary-module_refresh__2n8UO","refreshHeader":"ErrorBoundary-module_refreshHeader__B2ENR"};